
import React from "react";
import { type NodeTypes } from "@xyflow/react";
import { DocumentStoreNode } from "./triggerNodes/documentStoreNode";
import OcrProcessingNode from "./aiNodes/ocrProcessingNode";
import DocumentUploadNode from "./triggerNodes/documentUploadNode";
import ParsingNode from "./deprecatedNodes/parsingNode";
import MongoDBNode from "./exportNodes/mongodbNode";
import TransformNode from "./actionNodes/transformNode";
import WebhookNode from "./exportNodes/WebhookNode";
import { CompareDataNode } from "./aiNodes/compareDataNode";
import HTTPRequestNode from "./triggerNodes/httpRequestNode";
import OneDriveTriggerNode from "./triggerNodes/oneDriveTriggerNode";
import PDFGeneratorNode from "./actionNodes/pdfGeneratorNode";
import OneDriveUploadNode from "./exportNodes/oneDriveUploadNode";
import ForEachNode from "./conditionalNodes/forEachNode";
import SummarizeNode from "./aiNodes/summarizeNode";
import { IfElseNode } from "./conditionalNodes/ifElseNode";
import { SwitchNode } from "./conditionalNodes/switchNode";
import { GmailTriggerNode } from "./triggerNodes/gmailTriggerNode";
import { OutlookConnectorNode } from "./triggerNodes/outlookConnectorNode";
import { EmailParsingNode } from "./aiNodes/emailParsingNode";
import { ExportToExcelNode } from "./exportNodes/exportToExcelNode";
import { WordNode } from "./exportNodes/wordNode";
import { OutlookSendNode } from "./exportNodes/outlookSendNode";
import { GmailSendNode } from "./exportNodes/gmailSendNode";


import { SmartParseNode } from "./aiNodes/smartParseNode";
import CodeNode from "./actionNodes/codeNode/codeNode";
import HttpApiNode from "./actionNodes/httpApiNode/httpApiNode";
import CloudVisionNode from "./aiNodes/cloudVisionNode";
import { GoogleUnderstandingNode } from "./aiNodes/googleUnderstandingNode";
import { ErrorCatcherNode } from "./actionNodes/errorCatcherNode";
import { ValidatorNode } from "./conditionalNodes/validatorNode";
import { ScheduleNode } from "./triggerNodes/scheduleNode";
import { WebScraperNode } from "./actionNodes/webScraperNode";
import { DocxiqExportNode } from "./exportNodes/docxiqExportNode";
import { PostgresNode } from "./exportNodes/postgresNode";
import { withNodeExecutionStatus } from "../common/shared/withNodeExecutionStatus";

// Raw node components keyed by type. Wrapped below so every node shares one
// common execution loader / status overlay.
const rawNodeTypes: Record<string, React.ComponentType<any>> = {
    "DOCUMENT-STORE": DocumentStoreNode,
    "FILE-UPLOAD": DocumentUploadNode,
    "FILE-OCR": OcrProcessingNode,
    "FILE-PARSE": ParsingNode,
    "FILE-DATABASE": MongoDBNode,
    "TRANSFORM": TransformNode,
    "WEBHOOK": WebhookNode,
    "FILE-COMPARE": CompareDataNode,
    "HTTP": HTTPRequestNode,
    "HTTP-API": HttpApiNode,
    "ONEDRIVE-CONNECTOR": OneDriveTriggerNode,
    "GMAIL_CONNECTOR": GmailTriggerNode,
    "OUTLOOK-CONNECTOR": OutlookConnectorNode,
    "PDF": PDFGeneratorNode,
    "ONEDRIVE-UPLOAD": OneDriveUploadNode,
    "FOR-EACH": ForEachNode,
    "SUMMARY": SummarizeNode,
    "IF-ELSE": IfElseNode,
    "SWITCH": SwitchNode,
    "SMART-PARSE": SmartParseNode,
    "EMAIL-OCR": EmailParsingNode,
    "EXCEL": ExportToExcelNode,
    "WORD": WordNode,
    "CODE": CodeNode,
    "CLOUD-VISION": CloudVisionNode,
    "GEMINI-UNDERSTANDING": GoogleUnderstandingNode,
    "ERROR-CATCHER": ErrorCatcherNode,
    "VALIDATOR": ValidatorNode,
    "OUTLOOK-SEND": OutlookSendNode,
    "GMAIL-SEND": GmailSendNode,
    "SCHEDULE": ScheduleNode,
    "WEB-SCRAPER": WebScraperNode,
    "DOCXIQ-EXPORT": DocxiqExportNode,
    "POSTGRES": PostgresNode,
};

export const nodeTypes: NodeTypes = Object.fromEntries(
    Object.entries(rawNodeTypes).map(([key, Component]) => [
        key,
        withNodeExecutionStatus(Component),
    ]),
) as NodeTypes;

export {
    DocumentStoreNode,
    DocumentUploadNode,
    OcrProcessingNode,
    ParsingNode,
    MongoDBNode,
    TransformNode,
    WebhookNode,
    CompareDataNode,
    HTTPRequestNode,
    HttpApiNode,
    OneDriveTriggerNode,
    GmailTriggerNode,
    OutlookConnectorNode,
    PDFGeneratorNode,
    OneDriveUploadNode,
    ForEachNode,
    SummarizeNode,
    IfElseNode,
    SwitchNode,
    SmartParseNode,
    EmailParsingNode,
    ExportToExcelNode,
    WordNode,
    CodeNode,
    CloudVisionNode,
    GoogleUnderstandingNode,
    ErrorCatcherNode,
    ValidatorNode,
    OutlookSendNode,
    GmailSendNode,
    ScheduleNode,
    DocxiqExportNode,
    PostgresNode,
};